import { render, staticRenderFns } from "./ConsumedSalesTableHistory.vue?vue&type=template&id=0635f799"
import script from "./ConsumedSalesTableHistory.vue?vue&type=script&lang=js"
export * from "./ConsumedSalesTableHistory.vue?vue&type=script&lang=js"
import style0 from "./ConsumedSalesTableHistory.vue?vue&type=style&index=0&id=0635f799&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports